var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.005 97.2874H196.003V98.7874C196.003 147.921 159.592 188.542 112.294 195.134C107.871 195.747 103.345 196.068 98.7514 196.068C93.4476 196.068 88.2408 195.645 83.1718 194.827L83.1714 194.827C36.8676 187.37 1.5 147.205 1.5 98.7874C1.5 45.058 45.0459 1.5 98.7583 1.5C151.97 1.5 195.204 44.2497 196.005 97.2874Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.501 79.3234V100.843H139.114L134.9 129.832H112.501V196.62C108.01 197.243 103.415 197.568 98.7514 197.568C93.3679 197.568 88.0812 197.139 82.9329 196.308V129.832H58.3887V100.843H82.9329V74.5128C82.9329 58.1775 96.1704 44.9292 112.508 44.9292V44.9431C112.556 44.9431 112.598 44.9292 112.646 44.9292H139.121V69.9998H121.822C116.68 69.9998 112.508 74.1737 112.508 79.3165L112.501 79.3234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.d8ec6be6c76e7ea6c33b508de98f4db1.svg";
export { ForwardRef as ReactComponent };